import { render, staticRenderFns } from "./HmnStaffingRequirementTraceabilityModal.vue?vue&type=template&id=2b60ccbc&scoped=true"
import script from "./HmnStaffingRequirementTraceabilityModal.vue?vue&type=script&lang=js"
export * from "./HmnStaffingRequirementTraceabilityModal.vue?vue&type=script&lang=js"
import style0 from "./HmnStaffingRequirementTraceabilityModal.vue?vue&type=style&index=0&id=2b60ccbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b60ccbc",
  null
  
)

export default component.exports